// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanCreateOrganization } from "./hook";

export type CanCreateOrganizationProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanCreateOrganization({
  children,
  fallback,
  scope,
}: CanCreateOrganizationProps) {
  const canDoAction = useCanCreateOrganization(scope);
  return <>{canDoAction ? children : fallback}</>;
}
